﻿import { makeObservable, observable } from "mobx";

import { GraticuleState } from "../models/GraticuleState";
import { IStateStore, StateStore } from "./StateStore";

export class GraticuleStore extends StateStore<GraticuleState> implements GraticuleState, IStateStore<GraticuleState> {

    public visible: boolean = false;

    constructor() {
        super();
        makeObservable(this, {
            visible: observable
        });
    }

    public get getState(): GraticuleState {
        const { visible } = this;
        return { visible };
    }
}